"use client";

import React, { useRef } from "react";
import { useParallax } from "@/hooks/useParallax";
import styles from "./StudioHero.module.scss";

const StudioHero = () => {
	const headingRef = useRef<HTMLHeadingElement>(null);

	// Apply subtle parallax to heading
	useParallax(headingRef, {
		speed: 1.3,
		direction: "up",
		distance: 90,
		scrub: 1.5,
	});

	return (
		<section className={styles.hero}>
			<div className={styles["hero__first-part"]}>
				{/* <div className={styles.bg}></div> */}
				<img src="/images/about-logo.svg" alt="Parallel Lab Secondary Logo" className={styles.bg} />

				<div className={styles.hero__content}>
					<h1 ref={headingRef}>Welcome to the lab 🔬</h1>
					<h2 aria-label="a digital experience studio where fun meets function, and every pixel has purpose.">a digital experience studio where fun meets </h2>
				</div>
			</div>
			<div className={styles["hero__second-part"]}>
				<h2>function, and every pixel has purpose.</h2>
			</div>
			<div className={styles["studio-description"]}>
				<img src="/images/stamp-1.svg" alt="Inside the lab stamp" />
				<p>We create vivid, fun, and delightful digital experiences. The web is our preferred medium, but the real work is understanding what your brand needs to say, who needs to hear it, and building the most compelling way to make that connection happen.</p>
			</div>
		</section>
	);
};

export default StudioHero;
